interface GtmNarrativeBlockProps {
  narrative: string | null
  generatedAt: string | null
  error: string | null
  isLoading: boolean
  onRegenerate?: () => void
  isRegenerating?: boolean
}

export function GtmNarrativeBlock({
  narrative,
  generatedAt,
  error,
  isLoading,
  onRegenerate,
  isRegenerating = false,
}: GtmNarrativeBlockProps) {
  if (isLoading || isRegenerating) {
    return (
      <div>
        <div className="h-4 bg-fill-subtle rounded animate-pulse mb-2" style={{ width: '100%' }} />
        <div className="h-4 bg-fill-subtle rounded animate-pulse mb-2" style={{ width: '88%' }} />
        <div className="h-4 bg-fill-subtle rounded animate-pulse" style={{ width: '70%' }} />
        {isRegenerating && (
          <p className="text-[11px] text-faint mt-2">Regenerating GTM summary…</p>
        )}
      </div>
    )
  }

  if (error) {
    return (
      <div className="bg-chip-warn border border-warn/30 rounded-lg px-4 py-3 text-[13px] text-warn">
        <p>GTM narrative generation temporarily unavailable. The metrics above are correct.</p>
        {onRegenerate && (
          <button
            onClick={onRegenerate}
            className="mt-2 text-[12px] font-medium text-warn underline hover:no-underline"
          >
            ↻ Try again
          </button>
        )}
      </div>
    )
  }

  if (narrative) {
    return (
      <div>
        <p className="text-[14px] text-body leading-relaxed whitespace-pre-wrap">{narrative}</p>
        <div className="mt-3 flex items-start justify-between gap-4">
          <div className="bg-chip-warn border border-warn/30 rounded px-3 py-2 text-[11px] text-warn flex-1">
            <span className="font-medium">AI-generated</span>
            {generatedAt ? ` · ${new Date(generatedAt).toLocaleString()}` : ''}
            {'. '}
            This summary was generated by Claude Sonnet and is based on the scan findings.
            Verify with your product and engineering teams before sharing.
          </div>
          {onRegenerate && (
            <button
              onClick={onRegenerate}
              className="shrink-0 text-[11px] text-faint hover:text-body flex items-center gap-1 pt-2"
              title="Regenerate GTM summary"
            >
              ↻ Regenerate
            </button>
          )}
        </div>
      </div>
    )
  }

  return null
}
